import React from 'react'
import PropTypes from 'prop-types'
import FinancialAccountFormSection from './FinancialAccountFormSection/FinancialAccountFormSection'
import styles from './FinancialAccountFormGroup.module.scss'
import {
  getFinancialAccountData
} from 'utils/financialAccountTypes'

const FinancialAccountFormGroup = (props) => {
  const { setCollapsed } = props

  const financialAccountTypeComponent = (
    accountType,
    subType,
    financialAccountId,
    hasJointOwner,
    collapsed,
    sectionsOverview,
    financialAccounts
  ) => {
    const data = getFinancialAccountData(accountType, 'RAW_TYPE', subType)

    return (
      <FinancialAccountFormSection
        key={financialAccountId}
        hasJointOwner={hasJointOwner}
        financialAccountType={data.ACCOUNT_TYPE_ROUTE}
        financialAccountId={financialAccountId}
        name={data.DISPLAY}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        sectionsOverview={sectionsOverview}
        financialAccounts={financialAccounts} />
    )
  }

  const mappedFinancialAccounts = () => {
    const { financialAccounts, financialAccountsCollapsed, overview } = props
    const accounts = financialAccounts && financialAccounts.map((financialAccount) => {
      const { id, attributes: { financialAccountType, subType, jointOwner } }  = financialAccount
      const collapsed = financialAccountsCollapsed[id]
      const accountOverview = overview.find(account => account.financialAccountId === id)
      const sectionsOverview = accountOverview ? accountOverview.sections : []
      const args = [
        financialAccountType,
        subType,
        id,
        !!jointOwner,
        collapsed,
        sectionsOverview,
        financialAccounts
      ]
      return financialAccountTypeComponent(...args)
    })
    return accounts
  }

  return (
    <ul className={styles.heading}>
      {mappedFinancialAccounts()}
    </ul>
  )
}

FinancialAccountFormGroup.defaultProps = {
  financialAccounts: [],
  financialAccountsCollapsed: {},
  overview: [],
}

FinancialAccountFormGroup.propTypes = {
  financialAccounts: PropTypes.array,
  financialAccountsCollapsed: PropTypes.object,
  overview: PropTypes.array,
  setCollapsed: PropTypes.func.isRequired,
}

export default FinancialAccountFormGroup



// WEBPACK FOOTER //
// ./src/components/Onboarding/PWMSidebar/FinancialAccountFormGroup/FinancialAccountFormGroup.jsx